import React, { useState } from 'react';
import SVG from 'react-inlinesvg';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalVariant } from '@patternfly/react-core';
import dangerIcon from 'img/icons/danger-icon.svg';
import type LabEnvironmentStore from '../store';
import './styles.scss';

type LabErrorTableRowProps = {
  children: React.ReactNode;
};

const LabErrorTableRow = ({ children }: LabErrorTableRowProps) => (
  <span className="table-row">{children}</span>
);

type LabErrorModalProps = {
  labStore: LabEnvironmentStore;
};

const LabErrorModal: React.FC<LabErrorModalProps> = ({ labStore }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Button variant="link" onClick={() => setIsModalOpen(true)}>
        <SVG src={dangerIcon} />
      </Button>
      <Modal
        variant={ModalVariant.large}
        className="lab-error-modal container"
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={t('Lab Environment Error Tracking')}
        aria-label={t('Lab Environment Error Tracking')}
      >
        <p>{t('An error occurred when you tried to run the lab')}</p>
        <div className="lab-error-modal-content">
          {labStore.convertedComponents.map((component) =>
            component.events ? (
              <React.Fragment key={component.driver}>
                <h4>
                  {t(`Events details coming from ${component.driver} driver`)}
                </h4>
                <div className="lab-error-table-wrapper">
                  <span className="table-header">
                    <strong>Id</strong>
                  </span>
                  <span className="table-header">
                    <strong>{t('Event Time')}</strong>
                  </span>
                  <span className="table-header">
                    <strong>{t('Resource Name')}</strong>
                  </span>
                  <span className="table-header">
                    <strong>{t('Resource Status')}</strong>
                  </span>
                  <span className="table-header">
                    <strong>{t('Resource Status Reason')}</strong>
                  </span>
                  {component.events.map((event) => (
                    <React.Fragment key={event.id}>
                      <LabErrorTableRow>{event.id}</LabErrorTableRow>
                      <LabErrorTableRow>{event.event_time}</LabErrorTableRow>
                      <LabErrorTableRow>{event.resource_name}</LabErrorTableRow>
                      <LabErrorTableRow>
                        {event.resource_status}
                      </LabErrorTableRow>
                      <LabErrorTableRow>
                        {event.resource_status_reason}
                      </LabErrorTableRow>
                    </React.Fragment>
                  ))}
                </div>
              </React.Fragment>
            ) : null,
          )}
        </div>
        <div className="modal-footer-buttons">
          <Button variant="primary" onClick={() => setIsModalOpen(false)}>
            {t('Close')}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default LabErrorModal;
